import { createBrowserRouter, redirect, RouterProvider } from 'react-router'
import {
    Confirmation,
    ExchangeAddress,
    ItemSelection,
    Label,
    NotFound,
    Error,
    PickUp,
    ProcessSelectionPage,
    ReturnAddress,
    ReturnDetails,
    ReturnMethod,
    SuccessTracking,
    Tracking,
    TrackingUploadDocuments,
    ChangeCompensationMethod
} from './pages'
import { RefundMethodsPageEntry } from './pages/Portal/RefundMethodEntry.page'
import { LoginPage } from './pages/login/login.page'
import { AppLayout, PortalLayout, TrackingLayout } from './layout'
import { domains } from './utils/domains'

const createRouter = (basePath: string) => {
    return createBrowserRouter([
        {
            Component: AppLayout,
            path: basePath,
            errorElement: <Error />,
            children: [
                {
                    index: true,
                    Component: LoginPage
                },
                {
                    Component: PortalLayout,
                    children: [
                        {
                            path: 'order',
                            Component: ItemSelection,
                            children: [
                                {
                                    path: 'item-options',
                                    Component: null
                                }
                            ]
                        },
                        {
                            path: 'return-address',
                            Component: ReturnAddress
                        },
                        {
                            path: 'refund-method',
                            Component: RefundMethodsPageEntry
                        },
                        {
                            path: 'return-method',
                            Component: ReturnMethod
                        },
                        {
                            path: 'exchange-address',
                            Component: ExchangeAddress
                        },
                        { path: 'confirm', Component: Confirmation },
                        {
                            path: 'success-tracking',
                            loader: ({ request, params }) => {
                                const searchParams = new URL(request.url)
                                    .searchParams

                                const email = searchParams.get('email')
                                const processId = searchParams.get('processId')
                                const orderNumber =
                                    searchParams.get('orderNumber')

                                if (!email || !orderNumber || !processId) {
                                    throw redirect(`/${params.slug}`)
                                }

                                return null
                            },
                            Component: SuccessTracking
                        }
                    ]
                },
                { path: 'select', Component: ProcessSelectionPage },
                {
                    path: 'change-of-compensation-opm-bt',
                    Component: ChangeCompensationMethod
                },
                {
                    path: 'tracking',
                    Component: TrackingLayout,
                    children: [
                        { index: true, Component: Tracking },
                        { path: 'return-label', Component: Label },
                        { path: 'schedule-pickup', Component: PickUp },
                        { path: 'drop-off', Component: Label },
                        {
                            path: 'return-details',
                            Component: ReturnDetails
                        },
                        {
                            path: 'documents',
                            Component: TrackingUploadDocuments
                        }
                    ]
                },
                {
                    path: 'error',
                    Component: Error
                },
                {
                    path: '*',
                    Component: NotFound
                }
            ]
        },
        {
            path: 'error',
            Component: Error
        },
        {
            path: '*',
            Component: NotFound,
            errorElement: <Error />,
            HydrateFallback: () => null,
            loader: () => {
                if (!domains[window.location.hostname]) {
                    return Response.redirect('https://itsrever.com/')
                }

                return null
            }
        }
    ])
}

export const App = () => {
    const isCustomDomain = domains[window.location.hostname] !== undefined
    const basePath = isCustomDomain ? '/' : '/:slug/'

    const router = createRouter(basePath)

    return <RouterProvider router={router} />
}
